// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__2YPgh","tooltip":"Tooltip_tooltip__8rH4V","body":"Tooltip_body__lkTFx","arrow":"Tooltip_arrow__1JMT4","demo__link":"Tooltip_demo__link__3EwkL"};